import {
  Stack,
  HeroHeadingTwo,
  HeadingOne,
  TextLG,
  Text,
  Link,
  Button,
  Image,
  Box,
  Grid,
  HeadingFour,
} from "datastory-shared/ui"
import { Section } from "datastory-shared/sections"

import { getPageProps } from "utils/ssg"

const Page = () => {
  return (
    <>
      <Section>
        <Stack
          spacing="md"
          w="container.xxl"
          pb={["md", "lg"]}
          textAlign="center"
          alignItems="center"
        >
          <HeroHeadingTwo textAlign="center">
            The Story of Datastory
          </HeroHeadingTwo>
          <TextLG w={["auto", "container.md"]}>
            Every person has a desire to learn.
            <br />
            We just need to find that spark. ✨
          </TextLG>
        </Stack>
        <Stack spacing="md" w="container.xxl" pb="sm" alignItems="center">
          <HeadingOne textAlign="center">
            Datastory and Datastory.org
          </HeadingOne>
          <Text w={["auto", "container.md"]}>
            Civic education is our passion. We want everyone to have access to
            quality data, to understand the world’s most pressing issues through
            rich and pedagogical data visualizations, and to create
            knowledge-based dialogue and change. In order to best do that, we
            have two branches to our work: Datastory and Datastory.org.
            <br />
            <br />
            Datastory is where we develop scalable, cutting-edge technology for
            managing and visualizing data.
            <br />
            <br />
            Datastory.org is our free knowledge platform where we co-create
            tools together with researchers and data journalists. Using
            visualization, storytelling and open data, we democratize knowledge
            so that everyone can better navigate the complexities of the 21st
            century – using the best available data.
          </Text>
          <Link
            variant="standalone"
            textAlign="center"
            href="https://datastory.tech"
            pt="md"
            isExternal
          >
            <Button variant="solid" size="md" colorScheme="blurble" px="lg">
              Visit Datastory.tech
            </Button>
          </Link>
        </Stack>
      </Section>
      <Section bg="#F5EDFF">
        <Stack spacing="md" w="container.xxl" pb="sm" alignItems="center">
          <HeadingOne>Our Team</HeadingOne>
          <Text w={["auto", "container.sm"]}>
            We are a group of data scientists, journalists, designers and web
            developers from different countries and backgrounds. Our desire and
            shared goal is to make knowledge accessible to people all around the
            world.
          </Text>
        </Stack>
        <Image
          src={"/static/images/team.png"}
          alt="Team"
          width={1200}
          height={38}
          style={{ borderRadius: "8px" }}
        />
      </Section>
      <Section py={["lg", "xl"]} px="0" w="container.xxl">
        <Stack
          spacing="md"
          w="container.xxl"
          pb="sm"
          textAlign="center"
          alignItems="center"
        >
          <HeadingOne>Work with Datastory</HeadingOne>
          <TextLG whiteSpace="pre-line">
            {` What’s the story your data has been longing to tell?`}
            <br />
            {`We can help turn your data into impact.`}
          </TextLG>
        </Stack>

        <Grid variant="12">
          <Box
            height="100%"
            border="2px solid"
            borderColor="gray.100"
            borderRadius="md"
            p="lg"
            display="flex"
            flexDir="column"
            justifyContent="space-between"
          >
            <Stack spacing="md">
              <HeadingFour>Open data and research collaborations </HeadingFour>
              <Text>
                Does your organization want to do good with data? Do you have an
                idea for a collaboration with Datastory.org? Don’t hesitate to
                get in touch with us!
              </Text>
            </Stack>
            <Link
              variant="standalone"
              textAlign="center"
              pt="md"
              href="mailto:hello@datastory.org?subject=Inquiry to Datastory"
            >
              <Button variant="solid" size="md" colorScheme="blurble" px="lg">
                Contact us
              </Button>
            </Link>
          </Box>
          <Box
            height="100%"
            border="2px solid"
            borderColor="gray.100"
            borderRadius="md"
            p="lg"
            display="flex"
            flexDir="column"
            justifyContent="space-between"
          >
            <Stack spacing="md">
              <HeadingFour>Datastory Cloud</HeadingFour>
              <Text>
                Datastory Cloud is the multi-tool for data visualisation and
                management. Access quality open data to augment your datasets
                and create professional data websites without code.
              </Text>
              <Link
                variant="standalone"
                textAlign="center"
                href="https://datastory.tech"
                pt="md"
                isExternal
              >
                <Button variant="solid" size="md" colorScheme="blurble" px="lg">
                  Discover Datastory Cloud
                </Button>
              </Link>
            </Stack>
          </Box>
        </Grid>
      </Section>
    </>
  )
}

export const getStaticProps = async ({ locale: language }) =>
  await getPageProps({ language, namespaces: ["og_page--400127e6"] })

export default Page
